export default function PageTitle(props: Props) {
	const { title, sizeClasses } = props
	return (
		<div className="bg-white">
			<div className="max-w-4xl pt-2 pb-8 sm:pb-10">
				<h1
					className={
						'mt-1 font-black text-gray-900 sm:tracking-tight ' + sizeClasses
					}
				>
					{title}{' '}
				</h1>
			</div>
		</div>
	)
}
